import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {WeaveSelectComponent} from "./weave-select/weave-select.component";
import {AutocompleteSearchComponent} from "./autocomplete-search/autocomplete-search.component";
import {CurrencyInputComponent} from "./currency-input/currency-input.component";
import {InlineCheckboxesComponent} from "./inline-checkboxes/inline-checkboxes.component";
import {InlineDatePickerComponent} from "./inline-date-picker/inline-date-picker.component";
import {InlineEditComponent} from "./inline-edit/inline-edit.component";
import {InlineRadioButtonsComponent} from "./inline-radio-buttons/inline-radio-buttons.component";
import {InlineRepeaterComponent} from "./inline-repeater/inline-repeater.component";
import {InlineSelectComponent} from "./inline-select/inline-select.component";
import {InlineTextComponent} from "./inline-text/inline-text.component";
import {InlineTextareaComponent} from "./inline-textarea/inline-textarea.component";
import {PercentageInputComponent} from "./percentage-input/percentage-input.component";
import {SelectWithSearchComponent} from "./select-with-search/select-with-search.component";
import {SimpleDatePickerComponent} from "./simple-date-picker/simple-date-picker.component";
import {SimpleInputComponent} from "./simple-input/simple-input.component";
import {SimpleInputNumberComponent} from "./simple-input-number/simple-input-number.component";
import {WeaveButtonComponent} from "./weave-button/weave-button.component";
import {WeaveCheckboxComponent} from "./weave-checkbox/weave-checkbox.component";
import {WeaveCheckboxGroupComponent} from "./weave-checkbox-group/weave-checkbox-group.component";
import {WeaveCurrencyComponent} from "./weave-currency/weave-currency.component";
import {WeaveDatePickerComponent} from "./weave-date-picker/weave-date-picker.component";
import {WeaveEmailComponent} from "./weave-email/weave-email.component";
import {WeavePasswordComponent} from "./weave-password/weave-password.component";
import {WeaveRadioGroupComponent} from "./weave-radio-group/weave-radio-group.component";
import {WeaveRepeaterComponent} from "./weave-repeater/weave-repeater.component";
import {WeaveSearchComponent} from "./weave-search/weave-search.component";
import {WeaveSelectSearchComponent} from "./weave-select-search/weave-select-search.component";
import {WeaveTableEditComponent} from "./weave-table-edit/weave-table-edit.component";
import {WeaveTagsComponent} from "./weave-tags/weave-tags.component";
import {WeaveTextareaComponent} from "./weave-textarea/weave-textarea.component";
import {WeaveTextareaFlatComponent} from "./weave-textarea-flat/weave-textarea-flat.component";
import {WeaveTrueFalseComponent} from "./weave-true-false/weave-true-false.component";
import {MatSelectModule} from "@angular/material/select";
import {MatMenuModule} from "@angular/material/menu";
import {MatIconModule} from "@angular/material/icon";
import {MatSortModule} from "@angular/material/sort";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatTooltipModule} from "@angular/material/tooltip";
import {NgxMatSelectSearchModule} from "ngx-mat-select-search";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatNativeDateModule} from "@angular/material/core";
import {MatTableModule} from "@angular/material/table";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatDividerModule} from "@angular/material/divider";
import {MatDialogModule} from "@angular/material/dialog";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatRadioModule} from "@angular/material/radio";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatChipsModule} from "@angular/material/chips";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {
  GeneralWarningModalComponent
} from "../../components/shared/modals/general-warning-modal/general-warning-modal.component";
import {ContentEditableModelDirective} from "../../directives/content-editable-model.directive";
import {RouterModule} from "@angular/router";
import {
  ProgramSearchFilterPipe
} from "../../components/accreditation/evaluator-management/evaluators-list/program-search-filter.pipe";
import {SharedModule} from "../../components/shared/shared.module";
import {InputFieldDirective} from "../../directives/input-field.directive";
import {NgxCurrencyDirective} from "ngx-currency";
import {
  GeneralInfoModalComponent
} from "../../components/shared/modals/general-info-modal/general-info-modal.component";
import { NonZeroRequiredDirective } from "./non-zero-required.directive";



@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		ReactiveFormsModule,
		FormsModule,
		MatSelectModule,
		MatMenuModule,
		MatIconModule,
		MatSortModule,
		MatPaginatorModule,
		MatFormFieldModule,
		MatInputModule,
		MatTooltipModule,
		NgxMatSelectSearchModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatTableModule,
		MatProgressBarModule,
		MatDividerModule,
		MatDialogModule,
		MatCheckboxModule,
		MatRadioModule,
		MatSlideToggleModule,
		MatChipsModule,
		MatAutocompleteModule,
		RouterModule,
		NgxCurrencyDirective,
		NonZeroRequiredDirective,
	],
  declarations: [
    AutocompleteSearchComponent,
    CurrencyInputComponent,
    GeneralWarningModalComponent,
    GeneralInfoModalComponent,
    InlineCheckboxesComponent,
    InlineDatePickerComponent,
    InlineEditComponent,
    InlineRadioButtonsComponent,
    InlineRepeaterComponent,
    InlineSelectComponent,
    InlineTextComponent,
    InlineTextareaComponent,
    ProgramSearchFilterPipe,
    PercentageInputComponent,
    SelectWithSearchComponent,
    SimpleDatePickerComponent,
    SimpleInputComponent,
    SimpleInputNumberComponent,
    WeaveButtonComponent,
    WeaveCheckboxComponent,
    WeaveCheckboxGroupComponent,
    WeaveCurrencyComponent,
    WeaveDatePickerComponent,
    WeaveEmailComponent,
    WeavePasswordComponent,
    WeaveRadioGroupComponent,
    WeaveRepeaterComponent,
    WeaveSearchComponent,
    WeaveSelectComponent,
    WeaveSelectSearchComponent,
    WeaveTableEditComponent,
    WeaveTagsComponent,
    WeaveTextareaComponent,
    WeaveTextareaFlatComponent,
    WeaveTrueFalseComponent,
    ContentEditableModelDirective,
    InputFieldDirective,
  ],
  exports: [
    AutocompleteSearchComponent,
    CurrencyInputComponent,
    InlineCheckboxesComponent,
    InlineDatePickerComponent,
    InlineEditComponent,
    InlineRadioButtonsComponent,
    InlineRepeaterComponent,
    InlineSelectComponent,
    InlineTextComponent,
    InlineTextareaComponent,
    ProgramSearchFilterPipe,
    PercentageInputComponent,
    SelectWithSearchComponent,
    SimpleDatePickerComponent,
    SimpleInputComponent,
    SimpleInputNumberComponent,
    WeaveButtonComponent,
    WeaveCheckboxComponent,
    WeaveCheckboxGroupComponent,
    WeaveCurrencyComponent,
    WeaveDatePickerComponent,
    WeaveEmailComponent,
    WeavePasswordComponent,
    WeaveRadioGroupComponent,
    WeaveRepeaterComponent,
    WeaveSearchComponent,
    WeaveSelectComponent,
    WeaveSelectSearchComponent,
    WeaveTableEditComponent,
    WeaveTagsComponent,
    WeaveTextareaComponent,
    WeaveTextareaFlatComponent,
    WeaveTrueFalseComponent,
    InputFieldDirective,
  ]
})
export class WeaveFormsModule { }
